import React from "react";



export const Termsandconditions = () => {
	

	return (
		<div className="termsandconditions">
			<div className="innertermsandconditions">
				<h1 className="headingterms">Terms and Conditions</h1>
				<p>
					Welcome to Innbrieff, a platform that provides innovative services and
					features to help you stay ahead of the curve. These Terms of Service
					(TOS) set forth the terms and conditions that govern your use of
					Innbrieff's website and services. By accessing or using Innbrieff's
					platform, you agree to be bound by these TOS.
				</p>
				<div>
					<h3>Intended Use of Innbrieff</h3>
					<p>
						Innbrieff grants you a limited, non-exclusive, revocable license to
						access and use its platform in accordance with these TOS. You may
						not use Innbrieff's services in any manner that could damage,
						disable, overburden, or impair any Innbrieff server, or the
						network(s) connected to any Innbrieff server, or interfere with any
						other party's use and enjoyment of the platform. You may not attempt
						to gain unauthorized access to the platform or any systems or
						networks connected to the platform, or to any Innbrieff services or
						user accounts.
					</p>
					<h3>Account Responsibility</h3>
					<p>
						By using Innbrieff, you are responsible for maintaining the
						confidentiality of your account and password, and for restricting
						access to your computer. You agree to accept responsibility for all
						activities that occur under your account or password. If you believe
						that your account has been compromised, you must immediately change
						your password and notify Innbrieff.
					</p>

					<h3>Modifications to the Platform and TOS</h3>
					<p>
						Innbrieff reserves the right, at its sole discretion, to modify, add
						or delete portions of the platform and these TOS at any time. Any
						changes to the TOS will be effective immediately upon posting. You
						are responsible for regularly reviewing the TOS to stay informed of
						any changes. Your continued use of Innbrieff following the posting
						of changes to the TOS will mean you accept those changes.
					</p>
					<h3>Disclaimer of Warranties</h3>
					<p>
						Innbrieff makes no representations or warranties of any kind,
						express or implied, as to the operation of the platform or the
						information, content, materials or products included on the
						platform. You expressly agree that your use of the platform is at
						your own risk. To the fullest extent permissible by law, Innbrieff
						disclaims all warranties, express or implied, including but not
						limited to, implied warranties of merchantability and fitness for a
						particular purpose
					</p>
					<h3>Limitation of Liability</h3>
					<p>
						In no event shall Innbrieff be liable for any damages of any kind
						arising from the use of the platform, including but not limited to
						direct, indirect, incidental, punitive and consequential damages.
					</p>
					<h3>Intellectual Property</h3>
					<p>
						The platform and its original content, features, and functionality
						are and will remain the exclusive property of Innbrieff, and its
						licensors. The platform is protected by copyright, trademark, and
						other laws of both the United States and foreign countries. Nothing
						in these TOS grants you any right to use the Innbrieff name or any
						of its trademarks, logos, domain names, and other distinctive brand
						features.
					</p>
					<h3>Severability</h3>
					<p>
						If any provision of these TOS is found to be invalid, void, or for
						any reason unenforceable, that provision will be deemed severable
						and will not affect the validity and enforceability of the remaining
						provisions.
					</p>
				</div>
			</div>
		</div>
	);
};
